/**
 * Employee UI session in localStorage.
 * Password is verified by POST /api/auth/employee/login; the server session cookie is the real auth.
 */
export const EMPLOYEE_AUTH_KEY = 'employee-authenticated';
export const EMPLOYEE_EMAIL_KEY = 'employee-email';
export const EMPLOYEE_MUST_CHANGE_KEY = 'employee-must-change-password';

export function isEmployeeAuthenticated(): boolean {
  return localStorage.getItem(EMPLOYEE_AUTH_KEY) === 'true';
}

export function getEmployeeEmail(): string | null {
  const v = localStorage.getItem(EMPLOYEE_EMAIL_KEY);
  return v && v.trim() ? v.trim() : null;
}

export function mustChangeEmployeePassword(): boolean {
  return localStorage.getItem(EMPLOYEE_MUST_CHANGE_KEY) === 'true';
}

export function setEmployeeSession(email: string, mustChangePassword: boolean): void {
  localStorage.setItem(EMPLOYEE_AUTH_KEY, 'true');
  localStorage.setItem(EMPLOYEE_EMAIL_KEY, email.trim());
  localStorage.setItem(EMPLOYEE_MUST_CHANGE_KEY, mustChangePassword ? 'true' : 'false');
}

export function markEmployeePasswordChanged(): void {
  localStorage.setItem(EMPLOYEE_MUST_CHANGE_KEY, 'false');
}

export function clearEmployeeSession(): void {
  localStorage.removeItem(EMPLOYEE_AUTH_KEY);
  localStorage.removeItem(EMPLOYEE_EMAIL_KEY);
  localStorage.removeItem(EMPLOYEE_MUST_CHANGE_KEY);
}

export function notifyEmployeeAuthChanged(): void {
  window.dispatchEvent(new Event('employee-auth-change'));
}
